import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Link2 } from "lucide-react";

interface LinkGeneratorProps {
  storeId: string;
}

const LinkGenerator = ({ storeId }: LinkGeneratorProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Link2 className="h-5 w-5" />
          Link Generator
        </CardTitle>
        <CardDescription>Create and manage shareable store links</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">Store ID: {storeId}</p>
          <div className="p-8 border-2 border-dashed rounded-lg text-center">
            <Link2 className="h-12 w-12 mx-auto mb-4 text-muted-foreground" />
            <h3 className="font-medium mb-2">Link Generation Coming Soon</h3>
            <p className="text-sm text-muted-foreground">
              Create trackable links, QR codes, and share your store.
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default LinkGenerator;
